import { Box, styled } from '@mui/material';

import FormatNumberInput from '@Components/FormattedNumberInput';
import { FormInput } from '@Components/Form';
import { disabledFormInputStyles } from '@Components/Form/styles';
import { yearFields } from '../utils';
import { useNatureOfBusinessForm } from '../../NatureOfBusinessFormProvider';
import { IIncomeStructureFormValues } from '../../NatureOfBusinessFormProvider/types';

const FormNumberInput = styled(FormInput)({
  '& input': {
    textAlign: 'right',
  },
});

type ExportIncomeYearFieldsPctProps = {
  keyItem: string;
};

const ExportIncomeYearFieldsPct = ({
  keyItem,
}: ExportIncomeYearFieldsPctProps) => {
  const { watch } = useNatureOfBusinessForm();

  const incomeStructure = watch(
    'incomeStructure'
  ) as IIncomeStructureFormValues;

  const { isCompletedTh = false, isCompletedEn = false } =
    incomeStructure?.completedSection ?? {};

  return (
    <Box
      width={1}
      display={'grid'}
      gridTemplateColumns={'repeat(3, 1fr)'}
      gap={3}
      ml={1}
    >
      {yearFields.map((yearField) => (
        <FormNumberInput
          key={`${keyItem}-${yearField}`}
          name={`incomeStructure.exportIncomePercentages.${keyItem}.${yearField}`}
          placeholder={'กรุณาระบุจำนวน'}
          slotProps={{
            input: {
              inputComponent: FormatNumberInput as React.ComponentType,
            },
          }}
          fullWidth
          sx={
            isCompletedTh || isCompletedEn ? disabledFormInputStyles : undefined
          }
        />
      ))}
    </Box>
  );
};

export default ExportIncomeYearFieldsPct;
